<template>
  <div>
    <mf-tooltip variant="secondary" top max-width="250">
      <template v-slot:activator>
        <mf-button label="Importar produtos" @click="importDialog = true" />
      </template>
      <span> Para importações de arquivos com mais de 5000 itens, nosso sistema poderá apresentar instabilidades. </span>
    </mf-tooltip>

    <import-dynamic-csv
      v-model="importDialog"
      title="Importar produtos"
      import-label="Importar lista de produtos"
      :required-all-of="importRequiredAllOfFields"
      :fields="importFields"
      :boolean-configuration-options="importConfigurationOptions"
    />
    <falha-importacao-produtos-dialog
      v-model="failureDialog"
      :totalNumberOfLines="totalNumberOfLines"
      :failureResponse="failureResponse"
      :url-bucket="urlBucket"
    />
    <sucesso-importacao-produtos-dialog v-model="successDialog" :successResponse="successResponse" />
    <loading-dialog-standalone :loading="loading" />
  </div>
</template>

<script>
import { MUTATION_UPLOAD_PRODUCT } from '../../graphql'

export default {
  components: {
    ImportDynamicCsv: () => import('@/components/ImportDynamicCsv.vue'),
    FalhaImportacaoProdutosDialog: () => import('@/modules/produtos/gerenciamento-produtos/views/pages/FalhaImportacaoProdutosDialog.vue'),
    SucessoImportacaoProdutosDialog: () => import('@/modules/produtos/gerenciamento-produtos/views/pages/SucessoImportacaoProdutosDialog.vue'),
    LoadingDialogStandalone: () => import('@/components/LoadingDialogStandalone.vue'),
  },
  provide: function () {
    return {
      objectSelected: this.bulkUploadProducts,
      updateRequiredColumns: () => {},
    }
  },
  data: () => ({
    importDialog: false,
    failureDialog: false,
    successDialog: false,
    totalNumberOfLines: 0,
    failureResponse: {},
    successResponse: {},
    loading: false,
    urlBucket: '',
  }),
  computed: {
    importRequiredAllOfFields() {
      return ['sku', 'ean', 'name']
    },
    importFields() {
      return [
        { text: 'SKU', value: 'sku' },
        { text: 'EAN', value: 'ean' },
        { text: 'Descrição', value: 'name' },
      ]
    },
    importConfigurationOptions() {
      return [
        {
          label: 'Atualizar produtos pré-existentes',
          value: 'update_preexisting',
          tooltip: 'Se ativa, essa função atualiza as informações que já existem na plataforma e estão diferentes do que você importar agora',
        },
      ]
    },
  },
  methods: {
    async bulkUploadProducts({ file, selectedColumns, booleanConfigurationOptionsValues: { update_preexisting, fill_missing_eans } }) {
      this.loading = true
      try {
        const {
          data: { uploadProducts },
        } = await this.$apollo.mutate({
          mutation: MUTATION_UPLOAD_PRODUCT,
          variables: {
            file,
            data: {
              updatePreexisting: update_preexisting,
              columns: selectedColumns.reduce((acc, column, index) => (column ? { ...acc, [column]: index } : acc), {}),
            },
          },
          context: {
            uri: this.$microservicesUrls['products'],
            headers: {
              'x-apollo-operation-name': 'UploadProducts',
            },
          },
        })
        this.totalNumberOfLines = uploadProducts.total_number_of_lines
        if (!!uploadProducts.failure && uploadProducts.failure.totalFailures > 0) {
          this.failureResponse = uploadProducts.failure
          this.urlBucket = uploadProducts.failure.url
          this.failureDialog = true
        } else if (uploadProducts.success) {
          this.successResponse = uploadProducts.success
          this.successDialog = true
          this.$emit('success')
        }
      } catch (e) {
        console.log(e)
        this.$snackbar({ message: 'Falha ao importar arquivo de produtos.' })
      }
      this.loading = false
    },
  },
}
</script>
